/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useMultipleProjectsQuery } from '../../project/api';
import { getProjectSimulateView, type ProjectSimulateView } from '../paths';

const VIEW_LABELS: Record<ProjectSimulateView, string> = {
  runs: 'Runs',
  new: 'New run',
  run: 'Run',
  sweep: 'Sweep',
  mergedSweeps: 'Merged sweeps',
  compare: 'Compare',
  inputs: 'Inputs',
  financeModel: 'Finance model',
};

const projectOf = (path: string) => /^\/projects\/([^/?]+)\/simulate/.exec(path)?.[1];

/**
 * Labels of the Project Simulate window tabs, e.g. `Eagle Eye 1 · Compare`, from each tab's path:
 * tabs out of view are not mounted, so they cannot name themselves.
 */
export function useProjectSimulateTabLabels(paths: ReadonlyArray<string>) {
  const projectIds = [...new Set(paths.map(projectOf).filter((id): id is string => Boolean(id)))];
  const { data: projects } = useMultipleProjectsQuery(projectIds);
  return paths.map((path) => {
    const projectId = projectOf(path);
    if (!projectId) return undefined;
    const name = projects?.find((project) => project.id === projectId)?.name;
    const label = VIEW_LABELS[getProjectSimulateView(path.split('?')[0] ?? path).view];
    return name ? `${name} · ${label}` : label;
  });
}
